import {Time} from '@angular/common';
import {Component, Input} from '@angular/core';

@Component({
    selector: 'edu-udo-itmc-dev-mini-book-time-display',
    templateUrl: './time-display.component.html',
    styleUrls: ['./time-display.component.css'],
    standalone: false
})
export class TimeDisplayComponent {

  @Input()
  time: Time | undefined;

}
